import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { TiShoppingCart } from "react-icons/ti";
import { color } from "src/styles/variables";
import Tracking from "src/react/components/tracking";
import Expandable, {
  AnimatedExpandChevron,
} from "src/react/components/expandable";
import Product from "./product";

function CheckoutReviewProductsSummary({ products = [], basketQuantity = 0 }) {
  const [isOpened, setIsOpened] = useState(false);
  const title = `${
    isOpened ? "Hide" : "Show"
  } order summary (${basketQuantity})`;

  return (
    <Fragment>
      <Tracking
        tracking="custom"
        trackingOptions={{
          buttonLabel: title,
        }}
      >
        <TitleWrapper
          data-selector="CheckoutReviewProductsSummary-toggle"
          role="button"
          isOpened={isOpened}
          onClick={() => setIsOpened(!isOpened)}
        >
          <CustomCartIcon size={25} />
          <Title>{title}</Title>
          <AnimatedExpandChevron isDown={!isOpened} />
        </TitleWrapper>
      </Tracking>
      <Expandable isOpened={isOpened}>
        <Products>
          {products.map((product) => (
            <Product key={product.id} product={product} />
          ))}
        </Products>
      </Expandable>
    </Fragment>
  );
}

CheckoutReviewProductsSummary.propTypes = {
  products: PropTypes.array,
  basketQuantity: PropTypes.number,
};

export default CheckoutReviewProductsSummary;

export const TitleWrapper = styled.div`
  color: ${color.grey};
  padding-bottom: 20px;
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  border-bottom: 1px solid ${color.shipGrey};
  cursor: pointer;
`;

export const Title = styled.span`
  font-weight: 600;
  flex: 2;
  text-align: left;
`;

export const CustomCartIcon = styled(TiShoppingCart)`
  margin-right: 5px;
  vertical-align: middle;
`;

const Products = styled.div`
  margin-bottom: 20px;
`;
